import React, { useState } from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function Help() {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const faqs = [
    {
      category: "Getting Started",
      questions: [
        {
          q: "What is a digital business card?",
          a: "A digital business card is a modern, eco-friendly alternative to traditional paper business cards. It allows you to share your contact information instantly via QR code, NFC tag, or link. Recipients can save your details directly to their phone contacts with just one tap.",
        },
        {
          q: "How do I create my digital business card?",
          a: "Creating your digital business card is simple! Sign up for an account, fill in your contact information including name, phone number, email, job title, company, and social media links. You can customize your card with a profile photo and choose from various design templates. Once complete, you'll receive a unique QR code and link to share.",
        },
        {
          q: "Is there a mobile app?",
          a: "Yes! You can download our mobile app from the App Store (iOS) or Google Play Store (Android). The app makes it even easier to manage your digital business card on the go and share it with others using QR codes or NFC technology.",
        },
      ],
    },
    {
      category: "Sharing Your Card",
      questions: [
        {
          q: "How do I share my digital business card?",
          a: "There are multiple ways to share your digital business card: 1) Scan your QR code using any QR code scanner, 2) Share your unique link via text, email, or social media, 3) Use NFC technology to tap and share (requires NFC-enabled device), 4) Share directly from the mobile app. All methods allow recipients to save your information instantly.",
        },
        {
          q: "Can I share my card via QR code?",
          a: "Absolutely! Every digital business card comes with a unique QR code. You can display this QR code on your phone, print it on physical materials, or include it in presentations. When someone scans it, they'll see your contact information and can save it directly to their phone.",
        },
        {
          q: "What if the recipient doesn't have the app?",
          a: "No problem! Your digital business card works in any web browser. When someone scans your QR code or clicks your link, they'll be taken to a web page with all your contact information. They can save your details to their phone contacts without needing to download anything.",
        },
      ],
    },
    {
      category: "Customization & Updates",
      questions: [
        {
          q: "Can I customize the design of my card?",
          a: "Yes! You can customize your digital business card with your profile photo or your company logo. Changes are saved instantly and reflected immediately on your shared link and QR code.",
        },
        {
          q: "How do I update my contact information?",
          a: "Simply log into your account and edit any information you want to change. All updates are saved instantly and automatically reflected on your QR code and shared link. There's no need to re-share your card - existing links will show your updated information.",
        },
        {
          q: "Can I have multiple digital business cards?",
          a: "Yes, you can create multiple cards by creating a new account that is different from your main account. This is perfect for people who have multiple roles or want to separate their personal and professional contacts.",
        },
      ],
    },
    {
      category: "Privacy & Security",
      questions: [
        {
          q: "Is my information secure?",
          a: "Yes, we take your privacy seriously. Your contact information is stored securely. You control what information is visible on your card and who can access it. We comply with data protection regulations and never sell your information to third parties. Refer to our privacy policy for more details.",
        },
        {
          q: "Can I delete my digital business card?",
          a: "Yes, you can delete your account and all associated data at any time from your account settings. Once deleted, your QR code and link will no longer work, and all your information will be permanently removed from our servers.",
        },
      ],
    },
    {
      category: "Features & Benefits",
      questions: [
        {
          q: "What makes digital business cards better than paper cards?",
          a: "Digital business cards offer numerous advantages: they're eco-friendly (no printing waste), always up-to-date (no need to reprint when information changes), save directly to contacts (no manual entry), include rich media (links, social profiles, videos), and provide analytics (track who viewed your card). Plus, you'll never run out of cards!",
        },
        {
          q: "Can I add links to my social media profiles?",
          a: "Yes! You can add links to LinkedIn, Twitter, Instagram, Facebook, TikTok, and any other social media platforms or websites. You can also add custom links to your portfolio, blog, or company website. All links are clickable and will open directly from your card.",
        },
        {
          q: "Does it work offline?",
          a: "Your QR code can be scanned offline through the app or when printed on a physical card, but viewing and saving contact information requires an internet connection. However, once someone saves your contact to their phone, it's stored locally on their device and works completely offline.",
        },
      ],
    },
    {
      category: "Troubleshooting",
      questions: [
        {
          q: "Why isn't my QR code scanning?",
          a: "If your QR code isn't scanning, try these solutions: 1) Ensure the QR code is clear and not blurry, 2) Make sure there's adequate lighting, 3) Clean your camera lens, 4) Try a different QR code scanner app, 5) Ensure the QR code is not damaged or obscured. If issues persist, you can always share your card via the direct link instead.",
        },
        {
          q: "Can I print my QR code?",
          a: "Yes! You can download a high-resolution version of your QR code and print it on business cards, stickers, brochures, or any marketing materials. Make sure to print it at a sufficient size (at least 1 inch/2.5cm) for easy scanning.",
        },
        {
          q: "My NFC isn't working. What should I do?",
          a: "NFC requires both devices to have NFC enabled and be compatible. Make sure: 1) NFC is enabled in your phone settings, 2) Your device supports NFC (iPhone XS and newer, most Android phones), 3) The other person's device also has NFC enabled, 4) You're holding the devices close together (within a few centimeters). If NFC doesn't work, you can always use QR code or link sharing instead.",
        },
      ],
    },
  ];

  return (
    <>
      <TopNavbar />
      <h2 className="title txt-black" style={{ textAlign: "center", marginTop: 96 }}>
        Help & Support
      </h2>

      <section
        style={{
          marginTop: 40,
          marginLeft: 16,
          marginRight: 16,
          marginBottom: 80,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <p style={{ textAlign: "center", marginBottom: 50, fontSize: "18px", color: "#707070" }}>
                Find answers to common questions and learn how to make the most of your digital business card
              </p>

              {faqs.map((category, categoryIndex) => (
                <div key={categoryIndex} style={{ marginBottom: 50 }}>
                  <h3
                    className="txt-black"
                    style={{
                      fontSize: "24px",
                      fontWeight: 600,
                      marginBottom: 25,
                      color: "#0b093b",
                    }}
                  >
                    {category.category}
                  </h3>

                  <div style={{ marginBottom: 30 }}>
                    {category.questions.map((item, itemIndex) => {
                      const uniqueIndex = `${categoryIndex}-${itemIndex}`;
                      const isOpen = openItems[uniqueIndex];

                      return (
                        <div
                          key={itemIndex}
                          style={{
                            marginBottom: 15,
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            overflow: "hidden",
                            backgroundColor: "#fff",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                          }}
                        >
                          <button
                            onClick={() => toggleItem(uniqueIndex)}
                            style={{
                              width: "100%",
                              padding: "20px 25px",
                              textAlign: "left",
                              backgroundColor: isOpen ? "#006d5b" : "#fff",
                              color: isOpen ? "#fff" : "#0b093b",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "16px",
                              fontWeight: 600,
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                              if (!isOpen) {
                                e.currentTarget.style.backgroundColor = "#f5f5f5";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isOpen) {
                                e.currentTarget.style.backgroundColor = "#fff";
                              }
                            }}
                          >
                            <span>{item.q}</span>
                            <span
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                transition: "transform 0.3s ease",
                                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                              }}
                            >
                              ▼
                            </span>
                          </button>

                          {isOpen && (
                            <div
                              style={{
                                padding: "20px 25px",
                                backgroundColor: "#f9f9f9",
                                color: "#0b093b",
                                lineHeight: "1.8",
                                borderTop: "1px solid #e0e0e0",
                                animation: "fadeIn 0.3s ease",
                              }}
                            >
                              <p style={{ margin: 0, fontSize: "15px" }}>{item.a}</p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}

              {/* Contact Us Section */}
              <div
                style={{
                  marginTop: 80,
                  padding: "32px 16px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "12px",
                  textAlign: "center",
                  border: "1px solid #006d5b",
                }}
              >
                <h3
                  className="txt-black"
                  style={{
                    fontSize: "28px",
                    fontWeight: 600,
                    marginBottom: 0,
                    color: "#0b093b",
                  }}
                >
                  Contact Us
                </h3>
                <p
                  style={{
                    fontSize: "18px",
                    color: "#707070",
                    marginBottom: 30,
                    maxWidth: "600px",
                    margin: "0 auto 0px",
                  }}
                >
                  Still have questions? Our support team is here to help you!
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0,
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <a
                      href="tel:+250791430701"
                      style={{
                        fontSize: "20px",
                        color: "#006d5b",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = "underline";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = "none";
                      }}
                    >
                      +250 791 430 701
                    </a>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <a
                      href="mailto:contact@fabriq.rw"
                      style={{
                        fontSize: "20px",
                        color: "#006d5b",
                        fontWeight: 600,
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = "underline";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = "none";
                      }}
                    >
                      contact@fabriq.rw
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      <Footer />
    </>
  );
}
